import GroupTableCourseColumn from "./GroupTableCourseColumn";
export default GroupTableCourseColumn;
